/*
 * @Descripttion: 
 * @version: v1.0.0
 * @Author: Rafel
 * @Date: 2022-04-19 08:43:23
 * @LastEditors: Rafel
 * @LastEditTime: 2022-08-10 10:18:34
 */
import axios from 'axios'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL, // url = base url + request url
  timeout: 60000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // config.headers['X-Token'] = 111
    return config
  },
  error => {
    // do something with request error
    console.log('axios-request-err:' + error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    // if (res.code !== 20000) {
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return res
    // }
    return res
  },
  error => {
    console.log('axios-response-err: ' + error) // for debug
    return Promise.reject(error)
  }
)

export default service
